import { css } from '@emotion/react';

import generateEmotionClasses from '@core/utils/generateEmotionClasses';

export const classes = generateEmotionClasses('AccordionPanel', ['notPadded']);

export const getAccordionPanelCss = css`
  margin: 0 var(--cds-spacing-200) var(--cds-spacing-200) var(--cds-spacing-200);

  &.${classes.notPadded} {
    margin: 0 0 var(--cds-spacing-200) 0;
  }
`;
